export default __webpack_public_path__ + "static/stacked-column-16ab484c0bc9f9f18892f1379841ef92.png";